import { useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { useSession } from 'next-auth/react';
import { ShopTypes } from '~/lib/data-contract';
import useUserProfile from '~/services/shop/hooks/mit-fog/useUserProfile';
import { getMyOrder } from '../../operations/mit-fog';

export default function useMyOrderDetails(orderId: string) {
    const { data: profile } = useUserProfile();
    const { data } = useSession();
    const customerId = profile?.customer?.id ?? null;
    const token = data?.accessToken ?? null;

    return useQuery<ShopTypes.OrderDetailsResponse, HTTPError | Error>(
        ['myOrderDetails', { orderId, customerId, token }],
        ({ signal }) => getMyOrder({ signal, orderId, customerId, token }),
        {
            enabled: Boolean(data?.accessToken),
        },
    );
}
